<div>
  <ops-doc-header>
    <h1 mainTitle i18n>TERMS OF USE</h1>
  </ops-doc-header>
  <div class="ops-doc-container px-6">
    <table class="ops-doc-table">
      <tr>
        <td class="bg-l-blue" i18n>Date submitted</td>
        <td>
          {{ poaDetails.complaintDateReceived }}
        </td>
      </tr>
      <tr>
        <td class="bg-l-blue" i18n>Our case reference</td>
        <td>{{ poaDetails.complaintReference }}</td>
      </tr>
      <tr>
        <td class="bg-l-blue" i18n>Victim Name</td>
        <td>
          {{ poaDetails.reportingPersonFullName }}
        </td>
      </tr>
    </table>
    <div class="terms-of-service">
      @if (poaDetails.affiliateSource?.toUpperCase() === "LGT") {
        <poa-lgt />
      } @else {
        @switch (poaDetails.variant) {
          @case (TermsOfServiceVariant.Australia) {
            <poa-australia />
          }
          @case (TermsOfServiceVariant.NewZealand) {
            <poa-australia />
          }
          @case (TermsOfServiceVariant.FrenchSwiss) {
            <poa-french-swiss />
          }
          @case (TermsOfServiceVariant.GermanSwiss) {
            <poa-german-swiss />
          }
          @case (TermsOfServiceVariant.EuropeanInternational) {
            <poa-european-international />
          }
          @case (TermsOfServiceVariant.International) {
            <poa-international />
          }
        }
      }
    </div>
    <div class="ops-doc-border mt-20">
      <ops-doc-auth-table
        [complaintDateReceived]="poaDetails.complaintDateReceived"
        [complaintTimeReceived]="poaDetails.complaintTimeReceived" />
    </div>
    <div class="ops-doc-border mt-25">
      <app-policy-acceptance
        [affiliate]="poaDetails.affiliateSource"
        [readonly]="true"
        [form]="form" />
    </div>
    <h3 class="ops-doc-signature">
      {{ poaDetails.digitalSignature }}
    </h3>
    <p class="ops-doc-signature-clear">
      {{ poaDetails.digitalSignature }}
    </p>
    <hr />
  </div>
</div>
